var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"my-0"},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-checkbox',{staticClass:"ma-0 pa-0",attrs:{"dense":"","hide-details":"","input-value":_vm.includeTime,"disabled":_vm.disabled,"label":_vm.$t('checklist.date.include_time')},on:{"change":function($event){return _vm.handleInput({ includeTime: $event })}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }